import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/category/all", label: "全部漫画" },
  { to: "/category/romance", label: "恋爱" },
  { to: "/category/fantasy", label: "奇幻" },
  { to: "/category/action", label: "动作" },
  { to: "/category/thriller", label: "悬疑" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-book-open-line text-2xl ${scrolled || !isHome ? "text-primary-500" : "text-background-50"}`}></i>
            </div>
            <span
              className={`text-xl font-bold font-heading whitespace-nowrap ${
                scrolled || !isHome ? "text-foreground-900" : "text-background-50"
              }`}
            >
              韩漫画网
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors ${
                  location.pathname === link.to
                    ? scrolled || !isHome
                      ? "text-primary-500 font-medium"
                      : "text-background-50 font-medium bg-background-50/15"
                    : scrolled || !isHome
                      ? "text-foreground-600 hover:text-foreground-900"
                      : "text-background-50/80 hover:text-background-50"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer">
              <i className={`ri-search-line text-xl ${scrolled || !isHome ? "text-foreground-700" : "text-background-50"}`}></i>
            </button>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="w-9 h-9 flex items-center justify-center rounded-lg lg:hidden cursor-pointer"
            >
              <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"} ${scrolled || !isHome ? "text-foreground-700" : "text-background-50"}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-3 rounded-lg text-sm whitespace-nowrap ${
                  location.pathname === link.to
                    ? "text-primary-500 bg-primary-50 font-medium"
                    : "text-foreground-600 hover:text-foreground-900 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}